import { render, staticRenderFns } from "./IP_ByPSI.vue?vue&type=template&id=63121834&scoped=true&"
import script from "./IP_ByPSI.vue?vue&type=script&lang=js&"
export * from "./IP_ByPSI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63121834",
  null
  
)

export default component.exports